import React from 'react';
import { withRouter } from "react-router";
import Button from '../components/Button';
import './BackArrow.scss';

function BackArrow(props) {
  const handleClick = () => {
    props.history.go(-1);
  }

  return (
    <Button onClick={handleClick} className="button__back-arrow">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g id="ic_arrow_back" style={{ isolation: "isolate" }}>
          <rect id="rectangle" width="24" height="24" fill="none"/>
          <path id="path" d="M20,11H7.8l5.6-5.6L12,4,8.362,7.638,4,12l8,8,1.4-1.4L7.8,13H20V11Z" fill="#fff" fillRule="evenodd"/>
        </g>
      </svg>
    </Button>
  );
}

export default withRouter(BackArrow);